import Layout from "@views/layout";

const communityDashboardMemberRouter = {
    path: "/dashboard/member",
    component: Layout,
    redirect: "/dashboard/member/distribution",
    meta: {
        title: "会员看板",
        icon: "el-icon-data-analysis",
    },
    children: [
        {
            path: "distribution",
            name: "COMMUNITY_DASHBOARD_MEMBER_DISTRIBUTION",
            component: () => import("@views/dashboard/member/distribution.vue"),
            meta: {
                title: "会员分布",
                keepAlive: false,
            },
        },
        {
            path: "trend",
            name: "COMMUNITY_DASHBOARD_MEMBER_TREND",
            component: () => import("@views/dashboard/member/trend.vue"),
            meta: {
                title: "会员活跃趋势",
                keepAlive: false,
            },
        },
        {
            path: "ranking",
            name: "COMMUNITY_DASHBOARD_MEMBER_RANKING",
            component: () => import("@views/dashboard/member/ranking.vue"),
            meta: {
                title: "会员排行榜",
                keepAlive: false,
            },
        },
    ],
};

export default communityDashboardMemberRouter;
